{
  "de": {
    "messages": {
      "plaqueTool": {
        "attached": "%{vehicle} trägt jetzt die Plakette.",
        "hangarFailure": "Dein Hangar konnte nicht geladen werden.",
        "createFailure": "Das Schiff konnte deinem Hangar nicht hinzugefügt werden.",
        "addedWithoutPlaque": "Das Schiff ist in deinem Hangar, aber seine Plakette konnte nicht gespeichert werden. Versuche es erneut, um sie anzubringen.",
        "replaceConfirm": "Dieses Schiff hat bereits eine Plakette. Ersetzen?"
      },
      "blueprint": {
        "own": { "success": "%{blueprint} ist als vorhanden markiert" },
        "unown": {
          "success": "%{blueprint} ist nicht mehr als vorhanden markiert"
        },
        "want": {
          "success": "%{blueprint} wurde zu deiner Wunschliste hinzugefügt"
        },
        "unwant": {
          "success": "%{blueprint} wurde von deiner Wunschliste entfernt"
        }
      },
      "fleetchartScreenshot": {
        "failure": "Die Flottenübersicht konnte nicht als Bild gespeichert werden"
      },
      "buyback": {
        "destroy": {
          "failure": "Der Rückkauf-Pledge konnte nicht entfernt werden."
        }
      },
      "hangarShare": {
        "enable": {
          "success": "Freigabelink erstellt.",
          "failure": "Der Freigabelink konnte nicht erstellt werden."
        },
        "rotate": {
          "success": "Freigabelink erneuert. Der alte Link funktioniert nicht mehr.",
          "failure": "Der Freigabelink konnte nicht erneuert werden.",
          "confirm": "Wenn du den Link erneuerst, funktioniert der aktuelle nicht mehr. Alle, mit denen du ihn geteilt hast, brauchen dann den neuen Link."
        },
        "disable": {
          "success": "Freigabelink gelöscht.",
          "failure": "Der Freigabelink konnte nicht gelöscht werden.",
          "confirm": "Wenn du den Link löschst, funktioniert er für niemanden mehr, mit dem du ihn geteilt hast."
        },
        "copy": {
          "success": "Freigabelink in die Zwischenablage kopiert.",
          "failure": "Der Freigabelink konnte nicht kopiert werden."
        }
      },
      "loading": "Lädt…",
      "copy": {
        "success": "Text kopiert!",
        "failure": "Text konnte nicht kopiert werden"
      },
      "copyGitRevision": {
        "success": "Git Revision kopiert!",
        "failure": "Git Revision konnte nicht kopiert werden"
      },
      "copyImageUrl": {
        "success": "Bild-URL kopiert!",
        "failure": "Bild-URL konnte nicht kopiert werden"
      },
      "copyVideoUrl": {
        "success": "Video-URL kopiert!",
        "failure": "Video-URL konnte nicht kopiert werden"
      },
      "copyShareUrl": {
        "success": "URL \"%{url}\" kopiert!",
        "failure": "URL konnte nicht kopiert werden"
      },
      "copyInviteUrl": {
        "success": "Einladungs-URL \"%{url}\" kopiert!",
        "failure": "Einladungs-URL konnte nicht kopiert werden"
      },
      "copyTwoFactorProvisioningUrl": {
        "success": "Bereitstellungs-URL kopiert!",
        "failure": "Bereitstellungs-URL konnte nicht kopiert werden"
      },
      "copyBackupCodes": {
        "success": "Backup-Codes kopiert!",
        "failure": "Backup-Codes konnten nicht kopiert werden"
      },
      "signup": {
        "success": "<b>Willkommen bei FleetYards.net!</b> Dein Konto wurde erstellt. <br>Du erhältst eine Bestätigungs-E-Mail zur Aktivierung deines Kontos.",
        "invalid": "Bitte behebe die Fehler, bevor dein Konto erstellt werden kann.",
        "failure": "Wir konnten dein Konto nicht erstellen. Bitte versuche es später erneut."
      },
      "accountConfirm": {
        "success": "Dein Konto wurde erfolgreich bestätigt.<br>Du kannst dich jetzt anmelden.",
        "failure": "Dein Konto konnte nicht bestätigt werden."
      },
      "requestPasswordChange": {
        "success": "Falls deine E-Mail-Adresse in unserer Datenbank existiert, erhältst du in wenigen Minuten einen Link zur Passwort-Wiederherstellung."
      },
      "changePassword": {
        "success": "Dein Passwort wurde erfolgreich geändert.",
        "failure": "Dein Passwort konnte nicht aktualisiert werden."
      },
      "modelModule": {
        "update": {
          "failure": "Das Modul konnte nicht gespeichert werden."
        }
      },
      "updateProfile": {
        "success": "Profil aktualisiert.",
        "failure": "Profile could not be updated."
      },
      "updateHangar": {
        "failure": "Hangar-Einstellungen konnten nicht aktualisiert werden.",
        "success": "Hangar-Einstellungen aktualisiert."
      },
      "updatePrivacy": {
        "success": "Datenschutz-Einstellungen aktualisiert."
      },
      "features": {
        "updated": "Funktion aktualisiert.",
        "error": "Funktion konnte nicht aktualisiert werden.",
        "actorAdded": "Akteur zur Funktion hinzugefügt.",
        "actorRemoved": "Akteur von der Funktion entfernt.",
        "groupAdded": "Gruppe zur Funktion hinzugefügt.",
        "groupRemoved": "Gruppe von der Funktion entfernt.",
        "created": "Funktion erstellt.",
        "destroyed": "Funktion entfernt."
      },
      "rsiRequestLogs": {
        "resolved": "Anfrage-Log als gelöst markiert.",
        "error": "Anfrage-Log konnte nicht aktualisiert werden."
      },
      "updateNotifications": {
        "success": "Benachrichtigungs-Einstellungen aktualisiert.",
        "failure": "Deine Benachrichtigungseinstellungen konnten nicht gespeichert werden."
      },
      "pushNotifications": {
        "failure": "Push-Benachrichtigungen konnten nicht aktualisiert werden."
      },
      "updateAccount": {
        "success": "Konto aktualisiert."
      },
      "oauthApplications": {
        "create": {
          "success": "OAuth-Anwendung erstellt.",
          "error": "OAuth-Anwendung konnte nicht erstellt werden."
        },
        "update": {
          "success": "OAuth-Anwendung aktualisiert.",
          "error": "OAuth-Anwendung konnte nicht aktualisiert werden."
        },
        "destroy": {
          "success": "OAuth-Anwendung gelöscht.",
          "error": "OAuth-Anwendung konnte nicht gelöscht werden."
        },
        "regenerateSecret": {
          "success": "Client-Secret neu generiert.",
          "error": "Client-Secret konnte nicht neu generiert werden."
        },
        "copied": "In die Zwischenablage kopiert.",
        "copyError": "Konnte nicht in die Zwischenablage kopiert werden.",
        "secretWarning": "Kopieren Sie jetzt Ihren Client-Secret. Sie werden ihn nicht erneut sehen können."
      },
      "hangarImport": {
        "success": "Import abgeschlossen",
        "partialSuccess": "Import teilweise abgeschlossen.<br><br>Nicht gefundene Schiffe: <br>%{missing}",
        "failure": "Import fehlgeschlagen",
        "queued": "Import eingereiht. Du kannst ihn hier verfolgen."
      },
      "hangarExport": {
        "failure": "Export fehlgeschlagen. Bitte versuche es später erneut."
      },
      "vehicle": {
        "move": {
          "failure": "Die Reihenfolge konnte nicht gespeichert werden."
        },
        "add": {
          "success": {
            "noHtml": "Your new %{model} will be delivered to your Hangar",
            "paragraph1": "Your new ",
            "paragraph2": "will be delivered to your "
          }
        },
        "addToWishlist": {
          "success": {
            "noHtml": "Your new %{model} was added to your Wishlist",
            "paragraph2": "was added to your "
          }
        },
        "resetIngame": {
          "moveToWishlist": {
            "success": "Alle Ingame gekauften Schiffe wurden zu deiner Wunschliste verschoben.",
            "failure": "Nicht alle Ingame gekauften Schiffe konnten zu deiner Wunschliste verschoben werden."
          },
          "removeAll": {
            "confirm": "Alle ingame gekauften Schiffe aus deinem Hangar entfernen? Das kann nicht rückgängig gemacht werden.",
            "success": "Alle Ingame gekauften Schiffe wurden aus deinem Hangar entfernt.",
            "failure": "Nicht alle Ingame gekauften Schiffe konnten aus deinem Hangar entfernt werden."
          }
        }
      },
      "itemViews": {
        "syncStarted": "Synchronisierung der Ansichten gestartet. Lade die Seite neu, sobald die Renderings angehängt sind, um sie zu sehen."
      },
      "model": {
        "syncMatrixStarted": "Matrix-Synchronisation gestartet. Du wirst benachrichtigt, wenn sie abgeschlossen ist.",
        "syncScDataStarted": "SC-Daten-Synchronisation gestartet. Du wirst benachrichtigt, wenn sie abgeschlossen ist.",
        "importPaintsStarted": "Lackierungs-Import gestartet. Du wirst benachrichtigt, sobald er abgeschlossen ist.",
        "syncShipViewsStarted": "Synchronisierung der Schiffsansichten gestartet. Neue Renderings erscheinen hier, sobald sie verarbeitet sind.",
        "dimensionsDrifted": "Diese Maße weichen von den Spieldateien ab."
      },
      "announcement": {
        "created": "Ankündigung erstellt.",
        "updated": "Ankündigung aktualisiert.",
        "destroyed": "Ankündigung gelöscht.",
        "destroyFailed": "Die Ankündigung konnte nicht gelöscht werden.",
        "createFailed": "Ankündigung konnte nicht erstellt werden.",
        "updateFailed": "Ankündigung konnte nicht aktualisiert werden.",
        "testSent": "Test an den Admin-Discord-Kanal gesendet.",
        "testFailed": "Test konnte nicht gesendet werden.",
        "published": "Ankündigung ist unterwegs.",
        "publishFailed": "Ankündigung konnte nicht gesendet werden.",
        "retryQueued": "Zustellung erneut eingereiht.",
        "retryFailed": "Zustellung konnte nicht wiederholt werden.",
        "refreshQueued": "Die Zahlen werden aktualisiert.",
        "refreshFailed": "Die Zahlen konnten nicht aktualisiert werden."
      },
      "fundingGoal": {
        "created": "Finanzierungsziel angelegt.",
        "updated": "Finanzierungsziel aktualisiert.",
        "destroyed": "Finanzierungsziel gelöscht.",
        "createFailed": "Finanzierungsziel konnte nicht angelegt werden.",
        "updateFailed": "Finanzierungsziel konnte nicht aktualisiert werden."
      },
      "homepageSetting": {
        "updated": "Startseite gespeichert.",
        "updateFailed": "Startseite konnte nicht gespeichert werden."
      },
      "gameEvent": {
        "created": "Spiel-Event erstellt.",
        "updated": "Spiel-Event aktualisiert.",
        "destroyed": "Spiel-Event gelöscht.",
        "createFailed": "Spiel-Event konnte nicht erstellt werden.",
        "updateFailed": "Spiel-Event konnte nicht aktualisiert werden."
      },
      "supporterNomination": {
        "update": {
          "success": "Flottenauswahl aktualisiert.",
          "failure": "Flottenauswahl konnte nicht aktualisiert werden."
        },
        "change": {
          "confirm": "%{fleet} verliert möglicherweise die Flotten-Funktionen, die sie jetzt hat. Fortfahren?"
        }
      },
      "supporterContribution": {
        "created": "Unterstützer-Beitrag angelegt.",
        "updated": "Unterstützer-Beitrag aktualisiert.",
        "destroyed": "Unterstützer-Beitrag gelöscht.",
        "createFailed": "Unterstützer-Beitrag konnte nicht angelegt werden.",
        "updateFailed": "Unterstützer-Beitrag konnte nicht aktualisiert werden."
      },
      "notification": {
        "granted": "Willkommen bei FleetYards.net Benachrichtigungen!"
      },
      "twoFactor": {
        "invalidCode": "Dieser Code ist ungültig.",
        "enable": {
          "success": "Zwei-Faktor-Authentifizierung aktiviert!",
          "failure": "Zwei-Faktor-Authentifizierung konnte nicht aktiviert werden."
        },
        "disable": {
          "success": "Zwei-Faktor-Authentifizierung deaktiviert!",
          "failure": "Zwei-Faktor-Authentifizierung konnte nicht deaktiviert werden."
        },
        "backupCodes": {
          "failure": "Backup-Codes konnten nicht generiert werden."
        }
      },
      "error": {
        "usernameTaken": "Benutzername ist bereits vergeben.",
        "userNotFound": "Benutzer nicht gefunden",
        "emailTaken": "E-Mail-Adresse ist bereits vergeben.",
        "fleetTaken": "Flotte ist bereits vergeben.",
        "colorInvalid": "Color is invalid",
        "serialTaken": "Seriennummer ist bereits vergeben.",
        "textInvalid": "%{field} ist ungültig",
        "fleetNameInvalid": "Das Feld %{field} darf nur Buchstaben, Zahlen, Leerzeichen, Punkte, Binde- und Unterstriche enthalten",
        "vehicleSerialInvalid": "Das Feld %{field} muss wie die Registrierung im Spiel aussehen, etwa L8-4261-HA",
        "hangar": {
          "accountRequired": {
            "noHtml": "You need to Sign up or Login to add Ships to your Hangar.",
            "paragraph1": "You need to ",
            "paragraph2": " to add Ships to your Hangar.",
            "paragraph3": "Get more Information "
          }
        },
        "blueprint": {
          "accountRequired": "Registriere dich oder melde dich an, um deine Baupläne zu verwalten.",
          "update": "Der Bauplan konnte nicht aktualisiert werden. Bitte versuche es erneut."
        },
        "default": "<b>Etwas ist schief gelaufen.</b> <br>Hast du schon versucht, es aus- und wieder einzuschalten?"
      },
      "account": {
        "destroy": {
          "success": "<b>Dein Konto wurde gelöscht.</b> <br>Schade, dass du gehst :'(",
          "failure": "Wir konnten dein Konto nicht löschen! Bitte versuche es später erneut."
        },
        "calendarSubscription": {
          "enable": {
            "success": "Persönliches Kalender-Abo aktiviert.",
            "failure": "Kalender-Abo konnte nicht aktiviert werden."
          },
          "rotate": {
            "success": "Persönlicher Kalenderlink erneuert. Bestehende Abonnenten erhalten keine Updates mehr, bis sie das Abo neu einrichten.",
            "failure": "Persönlicher Kalenderlink konnte nicht erneuert werden.",
            "confirm": "Beim Erneuern des Links verliert jede Kalender-App, die die aktuelle URL abonniert hat, stillschweigend den Zugriff. Du musst das Abo mit dem neuen Link neu einrichten."
          },
          "disable": {
            "success": "Persönliches Kalender-Abo deaktiviert.",
            "failure": "Persönliches Kalender-Abo konnte nicht deaktiviert werden.",
            "confirm": "Beim Deaktivieren des Abos wird der Feed für jede aktuell abonnierte Kalender-App abgeschaltet."
          }
        },
        "supporterClaimKey": {
          "copy": {
            "success": "Schlüssel kopiert.",
            "failure": "Der Schlüssel konnte nicht kopiert werden."
          }
        }
      },
      "user": {
        "destroy": {
          "success": "Benutzer gelöscht.",
          "failure": "Benutzer konnte nicht gelöscht werden."
        }
      },
      "fleet": {
        "fidClaim": {
          "create": {
            "success": "Anspruch gestellt. Die Flotte mit dieser ID wurde informiert.",
            "failure": "Die Flotten-ID konnte nicht beansprucht werden."
          },
          "destroy": {
            "success": "Anspruch zurückgezogen.",
            "failure": "Der Anspruch konnte nicht zurückgezogen werden."
          },
          "endNow": {
            "success": "Schonfrist beendet.",
            "failure": "Die Schonfrist konnte nicht beendet werden."
          },
          "cancel": {
            "success": "Anspruch abgebrochen.",
            "failure": "Der Anspruch konnte nicht abgebrochen werden."
          }
        },
        "create": {
          "success": "Deine Flotte wurde erstellt.",
          "failure": "Flotte konnte nicht gespeichert werden."
        },
        "update": {
          "success": "Einstellungen gespeichert.",
          "failure": "Einstellungen konnten nicht gespeichert werden."
        },
        "destroy": {
          "success": "Deine Flotte wurde gelöscht.",
          "failure": "Wir konnten deine Flotte nicht löschen."
        },
        "leave": {
          "success": "Du hast die Flotte verlassen.",
          "failure": "Flotte konnte nicht verlassen werden."
        },
        "invites": {
          "accept": {
            "success": "Einladung angenommen.",
            "failure": "Einladung konnte nicht angenommen werden."
          },
          "decline": {
            "success": "Einladung abgelehnt.",
            "failure": "Einladung konnte nicht abgelehnt werden."
          },
          "create": {
            "failure": "Benutzer konnte nicht eingeladen werden."
          }
        },
        "members": {
          "update": {
            "success": "Einstellungen gespeichert.",
            "failure": "Einstellungen konnten nicht gespeichert werden."
          },
          "destroy": {
            "success": "Mitglied entfernt.",
            "failure": "Mitglied konnte nicht entfernt werden."
          },
          "demote": {
            "success": "Mitglied degradiert.",
            "failure": "Mitglied konnte nicht degradiert werden."
          },
          "promote": {
            "success": "Mitglied befördert.",
            "failure": "Mitglied konnte nicht befördert werden."
          },
          "accept": {
            "success": "Mitglied akzeptiert.",
            "failure": "Mitglied konnte nicht akzeptiert werden."
          },
          "decline": {
            "success": "Mitglied abgelehnt.",
            "failure": "Mitglied konnte nicht abgelehnt werden."
          },
          "nickname": {
            "success": "Spitzname gespeichert.",
            "failure": "Spitzname konnte nicht gespeichert werden."
          }
        },
        "roles": {
          "update": {
            "success": "Rolle gespeichert.",
            "failure": "Rolle konnte nicht gespeichert werden."
          }
        },
        "squadrons": {
          "create": {
            "success": "Staffel angelegt.",
            "failure": "Staffel konnte nicht angelegt werden."
          },
          "update": {
            "success": "Staffel gespeichert.",
            "failure": "Staffel konnte nicht gespeichert werden."
          },
          "destroy": {
            "confirm": "Soll die Staffel \"%{name}\" wirklich aufgelöst werden? Die Mitglieder bleiben in der Flotte.",
            "success": "Staffel aufgelöst.",
            "failure": "Staffel konnte nicht aufgelöst werden."
          },
          "sort": {
            "failure": "Die Reihenfolge konnte nicht gespeichert werden."
          },
          "ranks": {
            "update": {
              "success": "Staffelränge gespeichert.",
              "failure": "Staffelränge konnten nicht gespeichert werden."
            }
          },
          "members": {
            "add": {
              "success": "%{count} Mitglieder hinzugefügt.",
              "failure": "%{count} Mitglieder konnten nicht hinzugefügt werden."
            },
            "destroy": {
              "confirm": "„%{username}“ aus der Staffel „%{squadron}“ entfernen? Die Person bleibt in der Flotte.",
              "success": "Mitglied aus der Staffel entfernt.",
              "failure": "Mitglied konnte nicht entfernt werden."
            }
          },
          "join": {
            "success": "Du bist dem Team beigetreten.",
            "failure": "Dem Team konnte nicht beigetreten werden."
          },
          "leave": {
            "confirm": "Die Staffel %{squadron} verlassen? Du bleibst in der Flotte.",
            "success": "Du hast die Staffel verlassen.",
            "failure": "Die Staffel konnte nicht verlassen werden."
          },
          "requests": {
            "create": {
              "success": "Anfrage gesendet. Die Staffelführung wird sie beantworten.",
              "failure": "Anfrage konnte nicht gesendet werden."
            },
            "withdraw": {
              "success": "Anfrage zurückgezogen.",
              "failure": "Anfrage konnte nicht zurückgezogen werden."
            },
            "blocked": {
              "member": "Du bist bereits in %{squadron}. Verlasse sie, bevor du eine andere Staffel anfragst.",
              "requested": "Du hast angefragt, %{squadron} beizutreten. Ziehe diese Anfrage zurück, bevor du eine andere Staffel anfragst."
            },
            "accept": {
              "success": "%{username} ist der Staffel beigetreten.",
              "failure": "Anfrage konnte nicht angenommen werden."
            },
            "decline": {
              "success": "Anfrage abgelehnt.",
              "failure": "Anfrage konnte nicht abgelehnt werden."
            }
          },
          "rank": {
            "success": "Rang geändert.",
            "failure": "Rang konnte nicht geändert werden."
          }
        },
        "calendarSubscription": {
          "enable": {
            "success": "Kalender-Abo aktiviert.",
            "failure": "Kalender-Abo konnte nicht aktiviert werden."
          },
          "rotate": {
            "success": "Abo-Link erneuert. Bestehende Abonnenten erhalten keine Updates mehr, bis sie das Abo neu einrichten.",
            "failure": "Abo-Link konnte nicht erneuert werden.",
            "confirm": "Beim Erneuern des Links verliert jede Kalender-App, die die aktuelle URL abonniert hat, stillschweigend den Zugriff. Sie müssen das Abo mit dem neuen Link neu einrichten."
          },
          "disable": {
            "success": "Kalender-Abo deaktiviert.",
            "failure": "Kalender-Abo konnte nicht deaktiviert werden.",
            "confirm": "Beim Deaktivieren des Abos wird der Feed für jede aktuell abonnierte Kalender-App abgeschaltet."
          },
          "copy": {
            "success": "Kalenderlink kopiert. Füge ihn in deiner Kalender-App unter „Kalender abonnieren“ oder „Per URL hinzufügen“ ein.",
            "failure": "Kalenderlink konnte nicht kopiert werden."
          }
        }
      },
      "fleetInvite": {
        "used": "<b>Beitrittsanfrage für %{fleet} gesendet!</b><br>Sobald deine Mitgliedschaft akzeptiert wird, wirst du per E-Mail benachrichtigt",
        "failure": "Einladung konnte nicht verwendet werden.",
        "confirm": "Bist du sicher, dass du der Flotte beitreten möchtest: \"%{fleet}\"?"
      },
      "holoViewer": {
        "modelLoader": {
          "failure": "Wir konnten das angeforderte 3D-Modell nicht laden! Bitte versuche es später erneut."
        },
        "webglNotSupported": "Der 3D-Viewer ist auf diesem Gerät nicht verfügbar.",
        "tooLarge": "Dieses 3D-Modell ist %{size} MB groß und könnte für dieses Gerät zu groß sein."
      },
      "cargoGridViewer": {
        "confirmReset": "Möchtest du wirklich alle Schiffe und Container-Einstellungen zurücksetzen?"
      },
      "confirm": {
        "vehicleLoadout": {
          "moduleContents": {
            "one": "Das in diesem Modul ausgerüstete Teil wird mit entfernt.",
            "other": "Die %{count} in diesem Modul ausgerüsteten Teile werden mit entfernt."
          }
        },
        "vehicle": {
          "destroy": "Bist du sicher, dass du dieses Schiff aus deinem Hangar entfernen möchtest?"
        },
        "buyback": {
          "destroy": "Diesen Pledge aus deiner Rückkaufliste entfernen? Nutze das, nachdem du ihn auf RSI zurückgekauft hast. Der nächste Sync bringt ihn zurück, falls er dort noch gelistet ist."
        },
        "hangarGroup": {
          "destroy": "Bist du sicher, dass du diese Gruppe aus deinem Hangar entfernen möchtest?"
        },
        "hangar": {
          "import": "Importierte Schiffe werden zu deinem Hangar hinzugefügt, ohne sie mit vorhandenen Schiffen abzugleichen.<br><br>Unterstützte Formate sind: Fleetyards Export oder HangarXplor.<br><br>Möchtest du fortfahren?",
          "destroySelected": "Bist du sicher, dass du alle ausgewählten Schiffe aus deinem Hangar entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "destroyAll": "Bist du sicher, dass du alle Schiffe aus deinem Hangar entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "destroyAllTitle": "Alle Schiffe entfernen?"
        },
        "wishlist": {
          "destroyAll": "Bist du sicher, dass du alle Schiffe aus deiner Wunschliste entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "account": {
          "destroy": "Bist du sicher, dass du dein Konto löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "destroyWithFleets": "Du bist Admin der folgenden Flotte(n): %{fleets}. Wenn du dein Konto löschst, werden diese Flotten ebenfalls zerstört und alle Mitglieder entfernt. Diese Aktion kann nicht rückgängig gemacht werden. Fortfahren?"
        },
        "itemPrice": {
          "destroy": "Bist du sicher, dass du diesen Artikelpreis löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "fleet": {
          "leave": "Bist du sicher, dass du die Flotte verlassen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "destroy": "Bist du sicher, dass du deine Flotte löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "members": {
            "destroy": "Bist du sicher, dass du dieses Mitglied entfernen möchtest?",
            "remove": "Möchtest du dieses Mitglied wirklich aus der Flotte entfernen?"
          },
          "invites": {
            "decline": "Bist du sicher, dass du diese Einladung ablehnen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
          }
        },
        "oauthApplication": {
          "destroy": "Sind Sie sicher, dass Sie diese OAuth-Anwendung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
          "regenerateSecret": "Sind Sie sicher, dass Sie den Client-Secret neu generieren möchten? Bestehende Integrationen werden nicht mehr funktionieren."
        },
        "twoFactor": {
          "generateBackupCodes": "Bist du sicher, dass du deine Zwei-Faktor-Backup-Codes neu generieren möchtest?"
        },
        "user": {
          "loginAs": "Bist du sicher, dass du dich als dieser Benutzer anmelden möchtest?",
          "resendConfirmation": "Bist du sicher, dass du die Bestätigungs-E-Mail für diesen Benutzer erneut senden möchtest?",
          "sendPasswordReset": "Bist du sicher, dass du eine Passwort-Zurücksetzungs-E-Mail für diesen Benutzer senden möchtest?",
          "destroy": "Bist du sicher, dass du diesen Benutzer löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "destroyWithFleets": "Dieser Benutzer ist Admin der folgenden Flotte(n): %{fleets}. Beim Löschen des Benutzers werden diese Flotten ebenfalls zerstört und alle Mitglieder entfernt. Diese Aktion kann nicht rückgängig gemacht werden. Fortfahren?"
        },
        "itemViews": {
          "sync": "Bist du sicher, dass du die Ansichten dieses Gegenstands aus dem Render-Bucket synchronisieren möchtest? Neue und geänderte Renderings werden angehängt, entfernte kommen zurück. Eine Ansicht, die von Hand über ein importiertes Rendering hochgeladen wurde, bleibt erhalten."
        },
        "model": {
          "destroy": "Bist du sicher, dass du dieses Modell löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "sync": "Bist du sicher, dass du dieses Modell von RSI synchronisieren möchtest?",
          "syncMatrix": "Bist du sicher, dass du die Matrix-Daten für dieses Modell synchronisieren möchtest?",
          "syncScData": "Bist du sicher, dass du die SC-Daten für dieses Modell synchronisieren möchtest?",
          "importPaints": "Bist du sicher, dass du die Lackierungen dieses Modells aus den Hangar-Daten importieren möchtest? Eine Lackierung, die die Quelle für eine ganze Serie angibt, wird für jedes Modell dieser Serie importiert.",
          "syncShipViews": "Bist du sicher, dass du die Schiffsansichten dieses Modells aus dem Render-Bucket synchronisieren möchtest? Neue und geänderte Renderings werden angehängt, entfernte kommen zurück. Eine Ansicht, die von Hand über ein importiertes Rendering hochgeladen wurde, bleibt erhalten.",
          "exchangeStoreImage": "Bist du sicher, dass du das Store-Bild durch das RSI-Bild ersetzen möchtest?",
          "reloadMatrix": "Bist du sicher, dass du die Modell-Matrix neu laden möchtest? Dies wird Hintergrund-Jobs einreihen.",
          "reloadScData": "Bist du sicher, dass du die SC-Daten neu laden möchtest? Dies wird Hintergrund-Jobs einreihen.",
          "reloadPaints": "Bist du sicher, dass du die Lackierungen neu laden möchtest? Dies wird Hintergrund-Jobs einreihen.",
          "reloadModules": "Bist du sicher, dass du die Module neu laden möchtest? Dies wird Hintergrund-Jobs einreihen.",
          "reloadLoaners": "Bist du sicher, dass du die Leihschiffe neu laden möchtest? Dies wird Hintergrund-Jobs einreihen."
        },
        "manufacturer": {
          "destroy": "Bist du sicher, dass du diesen Hersteller löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "announcement": {
          "publish": "Diese Ankündigung an %{channels} senden? Das lässt sich nicht zurücknehmen.",
          "destroy": "Willst du diese Ankündigung wirklich löschen? Das lässt sich nicht rückgängig machen."
        },
        "fundingGoal": {
          "destroy": "Bist du sicher, dass du dieses Finanzierungsziel löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "gameEvent": {
          "destroy": "Willst du dieses Spiel-Event wirklich löschen? Das kann nicht rückgängig gemacht werden."
        },
        "supporterContribution": {
          "destroy": "Bist du sicher, dass du diesen Unterstützer-Beitrag löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "destroySelected": "Die ausgewählten Unterstützer-Beiträge löschen? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "modelPosition": {
          "destroy": "Bist du sicher, dass du diese Position löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "modelLoaner": {
          "destroy": "Sind Sie sicher, dass Sie dieses Leihschiff löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "modelSnubCraft": {
          "destroy": "Bist du sicher, dass du dieses Snub Craft löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "modelPaint": {
          "destroy": "Bist du sicher, dass du diese Lackierung löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "video": {
          "destroy": "Bist du sicher, dass du dieses Video löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "modelModule": {
          "destroy": "Bist du sicher, dass du dieses Modul löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "unlink": "Bist du sicher, dass du dieses Modul vom Modell trennen möchtest? Das Modul wird weiterhin existieren, aber nicht mehr mit diesem Modell verknüpft sein."
        },
        "modelUpgrade": {
          "destroy": "Bist du sicher, dass du dieses Upgrade löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "unlink": "Bist du sicher, dass du dieses Upgrade vom Modell trennen möchtest? Das Upgrade wird weiterhin existieren, aber nicht mehr mit diesem Modell verknüpft sein."
        },
        "modelModulePackage": {
          "destroy": "Bist du sicher, dass du dieses Modulpaket löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "dockCapacity": {
          "destroy": "Soll dieser Kapazitätseintrag wirklich gelöscht werden? Das lässt sich nicht rückgängig machen."
        },
        "dock": {
          "destroy": "Bist du sicher, dass du diesen Dock löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "component": {
          "destroy": "Bist du sicher, dass du diese Komponente löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "adminFleet": {
          "destroy": "Bist du sicher, dass du diese Flotte löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "adminNotifications": {
          "destroyAll": "Bist du sicher, dass du alle Benachrichtigungen löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "destroySelected": {
            "one": "Bist du sicher, dass du die ausgewählte Benachrichtigung löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
            "other": "Bist du sicher, dass du die %{count} ausgewählten Benachrichtigungen löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
          }
        },
        "adminFleetFidClaim": {
          "endNow": "Schonfrist jetzt beenden? Die bisherige Flotte wird umbenannt, und die beanspruchende Flotte bekommt die Flotten-ID sofort.",
          "cancel": "Diesen Anspruch abbrechen? Beide Flotten werden informiert, und die bisherige Flotte behält die Flotten-ID."
        },
        "fleetFidClaim": {
          "create": "Flotten-ID %{fid} beanspruchen? Die Flotte, die sie hat, wird jetzt informiert und verliert die ID in 14 Tagen, außer sie weist die RSI-Organisation selbst nach."
        },
        "adminDestroyedFleet": {
          "restore": "Bist du sicher, dass du diese Flotte wiederherstellen möchtest?",
          "restorePurged": "Bist du sicher, dass du diese endgültig gelöschte Flotte wiederherstellen möchtest? Die Wiederherstellung erfolgt nach bestem Bemühen: Rollen, Bilder, Einladungslinks und Flottenfahrzeuge werden nicht wiederhergestellt."
        },
        "adminUser": {
          "destroy": "Bist du sicher, dass du diesen Admin-Benutzer löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "image": {
          "destroy": "Bist du sicher, dass du dieses Bild löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "adminVehicle": {
          "destroy": "Bist du sicher, dass du dieses Fahrzeug löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "commodity": {
          "destroy": "Are you sure you want to delete this commodity? This action can't be reverted."
        },
        "equipment": {
          "destroy": "Are you sure you want to delete this equipment? This action can't be reverted."
        },
        "notifications": {
          "destroyAll": "Bist du sicher, dass du alle Benachrichtigungen löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
          "destroySelected": {
            "one": "Bist du sicher, dass du die ausgewählte Benachrichtigung löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
            "other": "Bist du sicher, dass du die %{count} ausgewählten Benachrichtigungen löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
          }
        },
        "unlistedModel": {
          "createModel": "Ein Schiff aus %{name} anlegen? Der nächste sc_data-Load ergänzt die Mechanik."
        },
        "import": {
          "cleanup": "Diesen Import als fehlgeschlagen markieren? Nur wenn der Job wirklich weg ist — ein noch laufender Durchlauf bricht am Ende mit einem Fehler ab.",
          "cleanupSelected": "Die ausgewählten Importe als fehlgeschlagen markieren? Betroffen sind nur die noch laufenden, und ein tatsächlich noch laufender Durchlauf bricht am Ende mit einem Fehler ab.",
          "cancel": "Diesen Import abbrechen? Bereits hinzugefügte Schiffe bleiben erhalten."
        },
        "hardpoint": {
          "destroy": "Bist du sicher, dass du diesen Aufhängungspunkt löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
        },
        "fleets": {
          "contractItem": {
            "destroy": "Diese Waren vom Auftrag entfernen?"
          }
        },
        "vehicleLog": {
          "destroy": "Möchtest du diesen Logbucheintrag wirklich entfernen?"
        }
      },
      "oauthAuthorize": {
        "loading": "Laden...",
        "loadError": "Autorisierungsdetails konnten nicht geladen werden.",
        "authorizeError": "Autorisierung fehlgeschlagen.",
        "denyError": "Autorisierungsablehnung fehlgeschlagen."
      },
      "oauth": {
        "disconnect": {
          "success": "Anbieter erfolgreich getrennt.",
          "failure": "Anbieter konnte nicht getrennt werden. Bitte versuchen Sie es erneut."
        }
      },
      "confirmAccess": {
        "failure": "Zugriff konnte nicht bestätigt werden. Bitte überprüfen Sie Ihr Passwort und versuchen Sie es erneut."
      },
      "setEmail": {
        "success": "Eine Bestätigungs-E-Mail wurde an deine neue E-Mail-Adresse gesendet. Bitte überprüfe deinen Posteingang.",
        "failure": "E-Mail-Adresse konnte nicht aktualisiert werden. Bitte versuche es erneut."
      },
      "confirmAccessEmail": {
        "sent": "Ein Bestätigungscode wurde an Ihre E-Mail gesendet.",
        "failure": "Bestätigungs-E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut."
      },
      "confirmAccessCode": {
        "failure": "Der Bestätigungscode ist ungültig oder abgelaufen."
      },
      "import": {
        "started": "%{type} Import gestartet...",
        "finished": "%{type} Import erfolgreich abgeschlossen.",
        "failed": "%{type} Import fehlgeschlagen: %{info}"
      },
      "buybackSync": {
        "started": "Deine Rückkauf-Pledges werden synchronisiert...",
        "success": "Deine Rückkauf-Pledges wurden synchronisiert.",
        "failure": "Deine Rückkauf-Pledges konnten nicht synchronisiert werden.",
        "detailsSuccess": "Preise und Versicherungen deiner Rückkauf-Pledges sind aktuell."
      },
      "syncExtension": {
        "started": "Synchronisiere deinen Hangar...",
        "success": "Dein Hangar wurde synchronisiert.",
        "failure": "Dein Hangar konnte nicht synchronisiert werden.",
        "cancelled": "Die Hangar-Synchronisierung wurde abgebrochen.",
        "pageNotRecognised": "Die Seite von RSI sieht anders aus, als FleetYards erwartet. Die Synchronisierung wurde deshalb ohne Änderungen abgebrochen.",
        "nothingToSync": "FleetYards hat in deinem RSI-Hangar keine Schiffe, Lackierungen oder Komponenten gefunden. Es wurde nichts geändert.",
        "onlySkippedItems": "Dein RSI-Hangar enthält nur Lackierungen oder Hangar-Flair, die diese Synchronisierung auslässt. Es wurde nichts geändert.",
        "nothingReadable": "Einige Gegenstände in deinem RSI-Hangar konnten nicht gelesen werden und FleetYards hat sonst nichts gefunden. Es wurde nichts geändert.",
        "notLoggedIn": "Du musst auf <a href=\"https://robertsspaceindustries.com\" target=\"_blank\">https://robertsspaceindustries.com</a> angemeldet sein, um deinen Hangar zu synchronisieren."
      },
      "admin": {
        "form": {
          "created": "Erstellt.",
          "updated": "Änderungen gespeichert."
        },
        "importLoaders": {
          "started": "%{name} gestartet.",
          "failed": "%{name} konnte nicht gestartet werden."
        },
        "supporterContributions": {
          "patreonSyncStarted": "Patreon-Synchronisierung gestartet. Aktualisiere in einer Minute, um importierte Unterstützer zu sehen.",
          "updatedBulk": {
            "one": "%{count} Beitrag aktualisiert",
            "other": "%{count} Beiträge aktualisiert"
          },
          "destroyedBulk": {
            "one": "%{count} Beitrag gelöscht",
            "other": "%{count} Beiträge gelöscht"
          },
          "bulkUnchanged": "In der Auswahl musste nichts geändert werden",
          "bulkError": "Die ausgewählten Beiträge konnten nicht geändert werden"
        },
        "imports": {
          "cleaned": "Import als fehlgeschlagen markiert",
          "cleanedUp": {
            "one": "%{count} Import als fehlgeschlagen markiert",
            "other": "%{count} Importe als fehlgeschlagen markiert"
          },
          "noneRunning": "In der Auswahl lief nichts mehr",
          "cleanupError": "Der Import konnte nicht bereinigt werden"
        }
      },
      "logistics": {
        "request": {
          "create": {
            "success": "Logistics request created.",
            "failure": "Could not create logistics request."
          }
        },
        "inventory": {
          "create": {
            "success": "Inventory created.",
            "failure": "Could not create inventory."
          },
          "update": {
            "success": "Inventory updated.",
            "failure": "Could not update inventory."
          },
          "destroy": {
            "confirm": "Inventar löschen? Alle Einträge darin werden mit gelöscht.",
            "success": "Inventar gelöscht.",
            "failure": "Inventar konnte nicht gelöscht werden."
          }
        },
        "inventoryItem": {
          "create": {
            "success": "Item added to inventory.",
            "failure": "Could not add item to inventory."
          },
          "deposit": {
            "success": "Deposit recorded.",
            "failure": "Could not record deposit."
          },
          "withdrawal": {
            "success": "Withdrawal recorded.",
            "failure": "Could not record withdrawal. Check available stock."
          },
          "destroy": {
            "success": "Entry deleted.",
            "failure": "Could not delete entry.",
            "confirm": "Delete this entry? The stock it added or removed is corrected accordingly."
          }
        },
        "comment": {
          "create": {
            "success": "Comment added.",
            "failure": "Could not add comment."
          }
        },
        "csvImport": {
          "success": "%{count} items imported successfully.",
          "failure": "Could not import CSV file."
        },
        "stockItem": {
          "update": {
            "success": "Item updated.",
            "failure": "Could not update item."
          },
          "destroy": {
            "success": "Item deleted.",
            "failure": "Could not delete item.",
            "confirm": "Delete this item and all %{count} of its entries? This cannot be undone."
          }
        },
        "vehicleInventory": {
          "clear": {
            "confirm": "Fracht dieses Schiffs leeren? Alle Buchungen werden gelöscht.",
            "success": "Fracht geleert.",
            "failure": "Fracht konnte nicht geleert werden."
          }
        },
        "transfer": {
          "needsAnswer": "Sie müssen dies annehmen, bevor es ankommt. Der Bestand verlässt dein Inventar jetzt und kommt zurück, wenn sie ablehnen.",
          "create": {
            "failure": "Transfer konnte nicht gesendet werden"
          },
          "resolve": {
            "failure": "Transfer konnte nicht aktualisiert werden"
          },
          "reportHint": "Eine Meldung lehnt den Transfer ab, sendet die Waren zurück und verhindert, dass dich dieser Absender erneut erreicht."
        }
      },
      "adminNotifications": {
        "read": "Benachrichtigung als gelesen markiert",
        "unread": "Benachrichtigung als ungelesen markiert",
        "archived": "Benachrichtigung archiviert",
        "unarchived": "Benachrichtigung zurück in den Posteingang verschoben",
        "readAll": "Alle Benachrichtigungen als gelesen markiert",
        "destroyed": "Benachrichtigung gelöscht",
        "destroyedAll": "Alle Benachrichtigungen gelöscht",
        "error": "Etwas ist schiefgelaufen",
        "bulk": {
          "read": {
            "one": "%{count} Benachrichtigung als gelesen markiert",
            "other": "%{count} Benachrichtigungen als gelesen markiert"
          },
          "unread": {
            "one": "%{count} Benachrichtigung als ungelesen markiert",
            "other": "%{count} Benachrichtigungen als ungelesen markiert"
          },
          "archived": {
            "one": "%{count} Benachrichtigung archiviert",
            "other": "%{count} Benachrichtigungen archiviert"
          },
          "unarchived": {
            "one": "%{count} Benachrichtigung zurück in den Posteingang verschoben",
            "other": "%{count} Benachrichtigungen zurück in den Posteingang verschoben"
          },
          "destroyed": {
            "one": "%{count} Benachrichtigung gelöscht",
            "other": "%{count} Benachrichtigungen gelöscht"
          }
        }
      },
      "fleets": {
        "notifications": {
          "update": {
            "success": "Benachrichtigungseinstellungen gespeichert.",
            "failure": "Benachrichtigungseinstellungen konnten nicht gespeichert werden."
          }
        },
        "mission": {
          "publish": {
            "success": "Mission veröffentlicht — die Flotte sieht sie jetzt.",
            "failure": "Mission konnte nicht veröffentlicht werden."
          },
          "create": {
            "success": "Mission erstellt.",
            "failure": "Mission konnte nicht erstellt werden."
          },
          "update": {
            "success": "Mission aktualisiert.",
            "failure": "Mission konnte nicht aktualisiert werden."
          },
          "archive": {
            "success": "Mission archiviert.",
            "failure": "Mission konnte nicht archiviert werden."
          },
          "unarchive": {
            "success": "Mission wiederhergestellt.",
            "failure": "Mission konnte nicht wiederhergestellt werden."
          },
          "destroy": {
            "success": "Mission gelöscht.",
            "failure": "Mission konnte nicht gelöscht werden.",
            "confirm": "Dadurch werden die Mission und alle ihre Teams, Schiffe und Slots endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden."
          }
        },
        "missionTeam": {
          "create": {
            "success": "Team hinzugefügt.",
            "failure": "Team konnte nicht hinzugefügt werden."
          },
          "update": {
            "success": "Team aktualisiert.",
            "failure": "Team konnte nicht aktualisiert werden."
          },
          "destroy": {
            "success": "Team entfernt.",
            "failure": "Team konnte nicht entfernt werden."
          }
        },
        "missionShip": {
          "create": {
            "success": "Schiff hinzugefügt.",
            "failure": "Schiff konnte nicht hinzugefügt werden."
          },
          "update": {
            "success": "Schiff aktualisiert.",
            "failure": "Schiff konnte nicht aktualisiert werden."
          },
          "destroy": {
            "success": "Schiff entfernt.",
            "failure": "Schiff konnte nicht entfernt werden."
          },
          "duplicate": {
            "success": "Schiff dupliziert.",
            "failure": "Schiff konnte nicht dupliziert werden."
          }
        },
        "missionSlot": {
          "create": {
            "success": "Slot hinzugefügt.",
            "failure": "Slot konnte nicht hinzugefügt werden."
          },
          "update": {
            "success": "Slot aktualisiert.",
            "failure": "Slot konnte nicht aktualisiert werden."
          },
          "destroy": {
            "success": "Slot entfernt.",
            "failure": "Slot konnte nicht entfernt werden."
          }
        },
        "event": {
          "create": {
            "success": "Event erstellt.",
            "failure": "Event konnte nicht erstellt werden."
          },
          "update": {
            "success": "Event aktualisiert.",
            "failure": "Event konnte nicht aktualisiert werden."
          },
          "archive": {
            "success": "Event archiviert.",
            "failure": "Event konnte nicht archiviert werden.",
            "confirm": "Dieses Event archivieren? Mitglieder sehen es dann nicht mehr in der Liste der anstehenden Events."
          },
          "unarchive": {
            "success": "Event aus dem Archiv wiederhergestellt.",
            "failure": "Event konnte nicht wiederhergestellt werden."
          },
          "syncToDiscord": {
            "success": "Event an Discord übertragen.",
            "failure": "Event konnte nicht an Discord übertragen werden.",
            "discord_missing_permissions": "Discord hat abgelehnt: Dem Bot fehlt eine Berechtigung in eurem Server. Welche, steht in den Discord-Einstellungen der Flotte."
          },
          "destroy": {
            "success": "Event gelöscht.",
            "failure": "Event konnte nicht gelöscht werden.",
            "confirm": "Dadurch wird das Event endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden."
          },
          "publish": {
            "success": "Event veröffentlicht — die Anmeldung ist jetzt offen.",
            "failure": "Event konnte nicht veröffentlicht werden."
          },
          "lockSignups": {
            "success": "Anmeldungen gesperrt.",
            "failure": "Anmeldungen konnten nicht gesperrt werden."
          },
          "unlockSignups": {
            "success": "Anmeldungen wieder freigegeben.",
            "failure": "Anmeldungen konnten nicht freigegeben werden."
          },
          "start": {
            "success": "Event gestartet.",
            "failure": "Event konnte nicht gestartet werden."
          },
          "complete": {
            "success": "Event als abgeschlossen markiert.",
            "failure": "Event konnte nicht abgeschlossen werden."
          },
          "cancel": {
            "success": "Event abgesagt.",
            "failure": "Event konnte nicht abgesagt werden.",
            "confirm": "Dieses Event absagen? Die Teilnehmer werden benachrichtigt."
          }
        },
        "eventSignup": {
          "create": {
            "success": "Du bist angemeldet.",
            "failure": "Anmeldung fehlgeschlagen."
          },
          "update": {
            "success": "Anmeldung aktualisiert.",
            "failure": "Anmeldung konnte nicht aktualisiert werden."
          },
          "withdraw": {
            "success": "Du hast dich vom Event abgemeldet.",
            "failure": "Abmeldung fehlgeschlagen.",
            "confirm": "Vom Event abmelden?"
          },
          "kick": {
            "success": "Anmeldung entfernt.",
            "failure": "Anmeldung konnte nicht entfernt werden.",
            "confirm": "Anmeldung dieses Mitglieds entfernen?"
          }
        },
        "eventAdmin": {
          "create": {
            "success": "Rolle vergeben.",
            "failure": "Rolle konnte nicht vergeben werden."
          },
          "destroy": {
            "success": "Rolle entzogen.",
            "failure": "Rolle konnte nicht entzogen werden.",
            "confirm": "%{username} die Rolle für dieses Event entziehen?"
          }
        },
        "eventTeam": {
          "create": {
            "success": "Team hinzugefügt.",
            "failure": "Team konnte nicht hinzugefügt werden."
          },
          "update": {
            "success": "Team aktualisiert.",
            "failure": "Team konnte nicht aktualisiert werden."
          },
          "destroy": {
            "success": "Team entfernt.",
            "failure": "Team konnte nicht entfernt werden.",
            "confirm": "Dieses Team mit allen seinen Schiffen und Slots entfernen?"
          }
        },
        "eventShip": {
          "create": {
            "success": "Schiff hinzugefügt.",
            "failure": "Schiff konnte nicht hinzugefügt werden."
          },
          "update": {
            "success": "Schiff aktualisiert.",
            "failure": "Schiff konnte nicht aktualisiert werden."
          },
          "destroy": {
            "success": "Schiff entfernt.",
            "failure": "Schiff konnte nicht entfernt werden.",
            "confirm": "Dieses Schiff und seine Slots entfernen?"
          }
        },
        "eventSlot": {
          "create": {
            "success": "Slot hinzugefügt.",
            "failure": "Slot konnte nicht hinzugefügt werden."
          },
          "update": {
            "success": "Slot aktualisiert.",
            "failure": "Slot konnte nicht aktualisiert werden."
          },
          "destroy": {
            "success": "Slot entfernt.",
            "failure": "Slot konnte nicht entfernt werden."
          }
        },
        "contract": {
          "create": {
            "success": "Auftrag erstellt",
            "failure": "Auftrag konnte nicht erstellt werden"
          },
          "update": {
            "success": "Auftrag gespeichert",
            "failure": "Auftrag konnte nicht gespeichert werden"
          },
          "item": {
            "create": {
              "failure": "Waren konnten nicht hinzugefügt werden"
            },
            "destroy": {
              "failure": "Waren konnten nicht entfernt werden"
            },
            "update": {
              "failure": "Die Waren konnten nicht geändert werden"
            }
          }
        },
        "contracts": {
          "deliverHint": "Sende die Waren aus einem deiner Inventare und wähle diesen Auftrag aus, damit die Lieferung zählt.",
          "expiredHint": "Dieser Auftrag ist abgelaufen und nimmt keine neuen Lieferungen mehr an. Lieferungen, die schon unterwegs sind, zählen weiterhin, sobald sie angenommen werden.",
          "actionFailed": "Das hat nicht geklappt - der Auftrag hat sich womöglich inzwischen geändert"
        }
      },
      "notifications": {
        "read": "Benachrichtigung als gelesen markiert",
        "unread": "Benachrichtigung als ungelesen markiert",
        "archived": "Benachrichtigung archiviert",
        "unarchived": "Benachrichtigung zurück in den Posteingang verschoben",
        "readAll": "Alle Benachrichtigungen als gelesen markiert",
        "destroyed": "Benachrichtigung gelöscht",
        "destroyedAll": "Alle Benachrichtigungen gelöscht",
        "actionDone": "Fertig",
        "actionFailed": "Das hat nicht funktioniert - die Benachrichtigung ist möglicherweise nicht mehr aktuell",
        "error": "Etwas ist schiefgelaufen",
        "bulk": {
          "read": {
            "one": "%{count} Benachrichtigung als gelesen markiert",
            "other": "%{count} Benachrichtigungen als gelesen markiert"
          },
          "unread": {
            "one": "%{count} Benachrichtigung als ungelesen markiert",
            "other": "%{count} Benachrichtigungen als ungelesen markiert"
          },
          "archived": {
            "one": "%{count} Benachrichtigung archiviert",
            "other": "%{count} Benachrichtigungen archiviert"
          },
          "unarchived": {
            "one": "%{count} Benachrichtigung zurück in den Posteingang verschoben",
            "other": "%{count} Benachrichtigungen zurück in den Posteingang verschoben"
          },
          "destroyed": {
            "one": "%{count} Benachrichtigung gelöscht",
            "other": "%{count} Benachrichtigungen gelöscht"
          }
        }
      },
      "imports": {
        "cancel": {
          "success": "Import abgebrochen",
          "error": "Import konnte nicht abgebrochen werden"
        }
      },
      "payouts": {
        "participantAddedUser": "%{name} mit FleetYards-Konto hinzugefügt",
        "participantAddedGuest": "%{name} als Gast hinzugefügt",
        "invalidAmount": "Gib einen Betrag ein, z. B. 1.500,50",
        "currencyUpdated": "Währung aktualisiert",
        "tourArchived": "Tour archiviert",
        "tourUnarchived": "Tour wiederhergestellt",
        "tourDeleted": "Tour gelöscht",
        "deleteTourConfirm": "Diese Tour löschen? Das kann nicht rückgängig gemacht werden.",
        "archiveTourConfirm": "Diese Tour archivieren? Sie verschwindet aus der Liste, die Abrechnung bleibt erhalten.",
        "entryCreated": "Eintrag erfasst",
        "entryUpdated": "Eintrag aktualisiert",
        "destroyEntryConfirm": "Diesen Eintrag löschen? Das kann nicht rückgängig gemacht werden.",
        "entryDestroyed": "Eintrag entfernt",
        "participantAdded": "Teilnehmer hinzugefügt",
        "participantRemoved": "Teilnehmer entfernt",
        "participantHasEntries": "Entferne zuerst dessen Einträge",
        "settled": "Auszahlungen berechnet",
        "reopened": "Buch wieder geöffnet",
        "tourCreated": "Tour erstellt",
        "tourCreateFailure": "Tour konnte nicht erstellt werden.",
        "tourJoined": "Du bist der Tour beigetreten",
        "settleConfirm": "Auszahlungen berechnen und das Buch sperren? Einträge lassen sich dann bis zum Wiederöffnen nicht mehr ändern.",
        "reopenConfirm": "Buch wieder öffnen? Die aktuelle Auszahlungsliste wird verworfen.",
        "participantNeedsName": "Gib einen Benutzernamen oder einen Namen ein",
        "weightUpdated": "Anteil aktualisiert",
        "joinRequested": "Deine Anfrage wurde gesendet",
        "joinRequestWithdrawn": "Anfrage zurückgezogen",
        "joinRequestApproved": "Anfrage angenommen",
        "joinRequestDeclined": "Anfrage abgelehnt",
        "expenseApproved": "Ausgabe freigegeben",
        "expenseDeclined": "Ausgabe abgelehnt",
        "pendingReview": "%{count} Ausgabe(n) warten auf Prüfung"
      },
      "dockAddition": {
        "create": {
          "failure": "Schiff konnte nicht hinzugefügt werden."
        },
        "destroy": {
          "failure": "Schiff konnte nicht entfernt werden."
        }
      },
      "dockCapacity": {
        "create": {
          "failure": "Kapazitätseintrag konnte nicht erstellt werden."
        },
        "update": {
          "failure": "Kapazitätseintrag konnte nicht gespeichert werden."
        },
        "destroy": {
          "failure": "Kapazitätseintrag konnte nicht gelöscht werden."
        }
      },
      "dock": {
        "create": {
          "failure": "Andockplatz konnte nicht angelegt werden."
        },
        "update": {
          "failure": "Andockplatz konnte nicht gespeichert werden."
        },
        "destroy": {
          "failure": "Andockplatz konnte nicht gelöscht werden."
        }
      },
      "relationships": {
        "user": {
          "addHint": "Gib den Benutzernamen der Person ein, die du hinzufügen möchtest. Sie wird gefragt, ob sie annimmt."
        },
        "fleet": {
          "addHint": "Gib den Slug der Flotte ein, mit der du dich verbünden möchtest. Ihre Admins werden gefragt."
        }
      },
      "friends": {
        "request": {
          "success": "Anfrage gesendet",
          "failure": "Anfrage konnte nicht gesendet werden"
        },
        "accept": {
          "success": "Anfrage angenommen",
          "failure": "Anfrage konnte nicht angenommen werden"
        },
        "decline": {
          "success": "Anfrage abgelehnt",
          "failure": "Anfrage konnte nicht abgelehnt werden"
        },
        "ignore": {
          "success": "Anfrage ignoriert",
          "failure": "Anfrage konnte nicht ignoriert werden"
        },
        "remove": {
          "success": "Entfernt",
          "failure": "Konnte nicht entfernt werden"
        }
      },
      "fleetAllies": {
        "request": {
          "success": "Anfrage gesendet",
          "failure": "Anfrage konnte nicht gesendet werden"
        },
        "accept": {
          "success": "Anfrage angenommen",
          "failure": "Anfrage konnte nicht angenommen werden"
        },
        "decline": {
          "success": "Anfrage abgelehnt",
          "failure": "Anfrage konnte nicht abgelehnt werden"
        },
        "ignore": {
          "success": "Anfrage ignoriert",
          "failure": "Anfrage konnte nicht ignoriert werden"
        },
        "remove": {
          "success": "Entfernt",
          "failure": "Konnte nicht entfernt werden"
        }
      },
      "vehiclePlaque": {
        "removeConfirm": "Die Widmungstafel dieses Schiffs entfernen?",
        "downloadFailure": "Die Tafel konnte nicht als Bild gespeichert werden",
        "failure": "Die Tafel konnte nicht gespeichert werden"
      },
      "vehicleOverview": {
        "image": {
          "success": "Bild gespeichert",
          "failure": "Das Bild konnte nicht gespeichert werden"
        },
        "paint": {
          "failure": "Die Lackierung konnte nicht angewendet werden"
        },
        "setting": {
          "failure": "Die Einstellung konnte nicht gespeichert werden"
        },
        "location": {
          "failure": "Der Standort konnte nicht gespeichert werden"
        }
      },
      "vehicleLog": {
        "create": {
          "success": "Logbucheintrag hinzugefügt",
          "failure": "Der Logbucheintrag konnte nicht hinzugefügt werden"
        },
        "update": {
          "success": "Logbucheintrag gespeichert",
          "failure": "Der Logbucheintrag konnte nicht gespeichert werden"
        },
        "destroy": {
          "failure": "Der Logbucheintrag konnte nicht entfernt werden"
        },
        "defaultUpdate": {
          "failure": "Die Einstellung konnte nicht gespeichert werden"
        }
      },
      "vehicleLoadout": {
        "failure": "Das Loadout konnte nicht gespeichert werden."
      },
      "hangarPledgeItems": {
        "addedToInventory": {
          "one": "%{count} Eintrag zu %{inventory} hinzugefügt",
          "other": "%{count} Einträge zu %{inventory} hinzugefügt"
        },
        "addToInventoryFailed": "Die Einträge konnten nicht zum Inventar hinzugefügt werden."
      }
    }
  }
}
